angular.module('wbControllers').controller 'SignupController',
['$scope', '$location', '$window', 'railsResource', 'users', 'analytics', 'locale',
($scope, $location, $window, $resource, users, analytics, locale) ->
  $scope.page = 'home'

  if $location.hash() is "signup"
    $scope.page = 'signup'

  $scope.$on '$locationChangeStart', ->
    if $location.hash() is "signup"
      $scope.forward('signup')

  $scope.forward = (page) ->
    $scope.direction = 'forward'
    $scope.page = page

  $scope.back = (page) ->
    $scope.direction = 'back'
    $scope.page = page

  $scope.startPlanning = ->
    $scope.showSignup()

  $scope.showSignup = ->
    $("body,html").animate scrollTop: 0, 400
    $scope.forward('signup') if $scope.page isnt 'signup'

  # This is necessary to handle label ID collisions on part of the site.
  $scope.toggleNewsletter = ->
    $scope.user.subscribedToNewsletter = !$scope.user.subscribedToNewsletter

  $scope.user = {}
  $scope.user.firstName = $location.search().firstName if $location.search().firstName
  $scope.user.lastName = $location.search().lastName if $location.search().lastName
  $scope.user.email = $location.search().email if $location.search().email

  state =
    submit: false,
    success: false,
    error: false

  $scope.state = state

  $scope.resetForm = ->
    state.error = state.success = state.submit = false

  $scope.register = (form) ->
    state.message = 'All fields must be filled out correctly before continuing' if form.$invalid
    return unless state.submit is false and form.$valid
    state.submit = true
    state.message = null
    $scope.user.language = locale.getCurrentLanguage()
    users.create($scope.user).then ->
      $window.location = '/signup/continue'
    .catch (e) ->
      state.class = 'error'
      state.message = e.data?.message
      state.submit = false

]
